import SidebarContent from "@/components/SidebarContent";

export default function Sidebar() {
  return (
    <aside
      data-testid="sidebar"
      className="hidden md:flex md:w-64 shrink-0 border-r border-[var(--app-line)] bg-white flex-col"
    >
      <SidebarContent />
    </aside>
  );
}
